module.exports = vendors_dc7e738d94ea4cc66adb;